import * as React from 'react';

import {Link, NavLink, useParams, useLocation} from 'react-router-dom';

import {Form, Formik, FormikProps} from 'formik';

import search from '@images/search_white.svg';

import {additionalResources} from '@app/components/UI/SidebarWithCaptions/SidebarWithCaptions';
import {eventToLink} from '@app/components/LocalCommon/Utils/eventToLink';

import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';

const MobileSlideInMenu = ({
	topics,
	onSetIssue,
	topicsInner = {},
	typeTopicsInner = {},
	typePage = '',
	onSubmit,
	searchFieldValue,
	setSearchFieldValue
}) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const [searchActive, setSearchActive] = React.useState(false);
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [searchValue, setSearchValue] = React.useState('');
	const [activeTopic, setActiveTopic] = React.useState('');

	const params = useParams();
	const location = useLocation();

	const callMenu = () => {
		setIsOpen(!isOpen);
		setSearchActive(false);
	};

	const callSearch = () => {
		setSearchActive(true);
	};

	const showActiveItemName = () => {
		const name = location.pathname
			.split('/')
			.splice(-1, 1)
			.join(' ')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');

		return name;
	};

	return (
		<div className="mobile-slidein-menu">
			{
				!searchActive ?
					<div>
						<button className="mobile-slidein-menu-trigger" onClick={callMenu}>
							{
								activeTopic ? activeTopic : showActiveItemName()
							}
							</button>
						<button className="mobile-slidein-menu-search" onClick={callSearch}><img src={search} alt="search-icon"/></button>
					</div>
				:
					<div>
						<Formik
							onSubmit={(values) => {
							}}
							initialValues={{searchQuery: ''}}

							render={(formikBag: FormikProps<any>) => {
								return(
									<Form>
										<SearchFieldAuto
											name={'searchQuery'}
											placeholder="Search by topic"
											formikBag={formikBag}
											onChange = {(value, option) => {
												setSearchFieldValue(value);
												!value && onSubmit && onSubmit('') && setSearchFieldValue('');
											}}
											onSearch ={() => {
												searchFieldValue ? onSubmit && onSubmit(searchFieldValue) :
													setSearchActive(false);
											}}
											buttonType="submit"
											searchButton={true}
											allowClear={true}
											label={searchFieldValue}
										/>
									</Form>
								);
							}}
						/>
					</div>
			}

			<div className={isOpen ? 'mobile-slidein-menu-nav active-mobile' : 'mobile-slidein-menu-nav'}>
			{
				topics &&
				<>
					<ul className="mobile-slidein-menu-nav__body">
						{typePage === 'NEWS_PAGE' &&
							<li className="mobile-slidein-menu-nav__section">
								<div className="mobile-slidein-menu-nav-header">
									<h5>In the News</h5>
									<button type="button" className="btn btn-icon mobile-menu-button mobile-slidein-menu-nav-header-close" onClick={callMenu}>
										<img className="btn-icon-image_hover" src={require('@app/images/close_white.svg')} alt="search" width="16" />
									</button>
								</div>
								<ul className="mobile-slidein-menu-nav-list">
									{topics.map((item, indexInner) => (
										<li key={indexInner} className="sidebar-menu__section-content__item">
											<NavLink
												to={`/in-the-news/${item.url}`}
												className="mobile-slidein-menu-nav-list-item"
												activeClassName="active"
												onClick={() => {
													onSetIssue(item);
													setIsOpen(false);
													setActiveTopic(item.title);
												}}>
												{item.name}
											</NavLink>
										</li>
									))}
								</ul>
							</li>
						}
						{!typePage &&
							<>
							<li className="mobile-slidein-menu-nav__section">
								<div className="mobile-slidein-menu-nav-header">
									<h5>Resource Topics</h5>
									<button type="button" className="btn btn-icon mobile-menu-button mobile-slidein-menu-nav-header-close" onClick={callMenu}>
										<img className="btn-icon-image_hover" src={require('@app/images/close_white.svg')} alt="search" width="16" />
									</button>
								</div>
								<ul className="mobile-slidein-menu-nav-list">
									{topics.map((item, index) =>
										(
											<li key={index}>
												<NavLink
													to={`/resource-center/${item.url}`}
													className="mobile-slidein-menu-nav-list-item"
													activeClassName="active"
													onClick={() => {
														onSetIssue['Common'](item);
														setIsOpen(false);
														setActiveTopic(item.title);
													}}
												>
													{item.name}
												</NavLink>
											</li>
										)
									)}
								</ul>
							</li>

							<li className="mobile-slidein-menu-nav__section">
								<div className="mobile-slidein-menu-nav-header">
									<h5>Additional Resources</h5>
								</div>
								<ul className="mobile-slidein-menu-nav-list">
									{additionalResources.map((resource, indexInner) => (
										<li key={indexInner} className="sidebar-menu__section-content__item">
											{
												resource.url !== 'quality-of-life-calendar.pdf' ?
													<NavLink
														to={`/${resource.url}`}
														className="mobile-slidein-menu-nav-list-item"
														activeClassName="active"
														onClick={() => {
															onSetIssue[resource.name](resource);
															// resource.name !== 'Blog' && resource.name !== 'FAQ' ?
															setIsOpen(false);
															setActiveTopic('');
															eventToLink(resource.title ? resource.title : resource.name);
															// : null;
														}}>
														{resource.title ? resource.title : resource.name}
													</NavLink>
													:  <Link
														to={`/${resource.url}`}
														target="_blank"
														className="mobile-slidein-menu-nav-list-item"
														onClick={() => {
															onSetIssue[resource.name](resource);
															setIsOpen(false);
															eventToLink(resource.title ? resource.title : resource.name);
														}}>
														{resource.title ? resource.title : resource.name}
													</Link>
											}

											{typeTopicsInner && topicsInner && resource.url === typeTopicsInner &&
											<ul className="mobile-slidein-menu-nav-list mobile-slidein-menu-nav-list_inner">
												{topicsInner[resource.name] ? topicsInner[resource.name].map((topic, indexInner) => (
													<li key={indexInner} className="sidebar-menu__section-content__item">
														<NavLink
															to={`/${resource.url}/${topic.name.toLowerCase().replace(/[&]/g, 'and').replace(/\s+/g, '-')}`}
															className="mobile-slidein-menu-nav-list-item"
															activeClassName="active"
															onClick={() => {
																onSetIssue[resource.name](topic);
																setIsOpen(false);
															}}
														>
															{topic.name}
														</NavLink>
													</li>
												)) : null}
											</ul>
											}
										</li>
									))}
								</ul>
							</li>
							</>
						}
					</ul>
				</>
			}
			</div>
		</div>
	);
};

export default MobileSlideInMenu;